var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandbag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H7.71094C6.74786 8 6.26653 8 5.87598 8.17521C5.5317 8.32965 5.23841 8.57838 5.02947 8.89258C4.79244 9.24902 4.71276 9.72386 4.55443 10.6738L3.62109 16.2738L3.62072 16.2759C3.40728 17.5565 3.3005 18.1972 3.48595 18.6965C3.64877 19.1348 3.96058 19.5022 4.36621 19.7349C4.82844 20 5.47776 20 6.77734 20H17.2224C18.522 20 19.1724 20 19.6346 19.7349C20.0402 19.5022 20.3513 19.1348 20.5141 18.6965C20.6995 18.1974 20.5928 17.557 20.3795 16.2774L20.3786 16.2738L19.4453 10.6738C19.287 9.72386 19.2077 9.24902 18.9707 8.89258C18.7618 8.57838 18.4682 8.32965 18.124 8.17521C17.7334 8 17.2524 8 16.2893 8H16M8 8H16M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandbag);
export default __webpack_public_path__ + "static/media/Handbag.4893cf772d9b4b1a012c65d0af30337b.svg";
export { ForwardRef as ReactComponent };